<template>
    <svg width="1.125em" height="1.125em" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.25 15V3L16.5 9L2.25 15ZM3.375 13.2562L13.575 9L3.375 4.6875V7.8375L7.9125 9L3.375 10.125V13.2562ZM3.375 13.2562V9V4.6875V7.8375V10.125V13.2562Z" fill="currentColor"/>
    </svg>
</template>
